import { render, staticRenderFns } from "./colortext.vue?vue&type=template&id=27e952ea"
import script from "./colortext.vue?vue&type=script&lang=js"
export * from "./colortext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports